import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(
  (theme) => ({
    root: {
      width: '100%',
      backgroundColor: theme.palette.background.paper,
      borderRight: 'solid 0.5px #eaeaea',
    },
    listItemInactive: {},
    selected: {
      color: theme.palette.primary.main,
    },
    listItemRoot: {
      '&$selected': {
        backgroundColor: theme.palette.background.paper,
      },
    },
    listItemActive: {
      borderRight: `solid 5px ${theme.palette.primary.main}`,
    },
    listMainMenuActive:{
      backgroundColor : '#F0F1F2!important',
      '& ::before': { 
        content: '""',
        position: 'absolute',
        left: 0,
        top: 0,
        width: '5px',
        background: '#0074C7',
        height: '100%', },
    },
    iconRoot: {
      color: theme.palette.primary.main,
    },
    logoBox: {
      display: 'grid',
      '&>img': {
        placeSelf: 'center',
        width: 35,
      },
    },
    logoItem: {
      paddingTop: '0!important',
      paddingBottom: '0!important',
    },
    listItemIcon: {
      paddingLeft: '8px',
    },
    listItemIconWidth: {
      minWidth: '0!important',
    },
    menuText: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    logoText: {
      fontSize: '1.125rem',
    }
  }),
  // {
  //   name: 'MenuList',
  // },
);
